import { createInertiaApp } from '@inertiajs/svelte'
import  { mount,hydrate } from 'svelte';
import Layout from '../lib/layouts/Layout.svelte'
import AppLayout from '../lib/layouts/AppLayout.svelte'


// 🌟 1. 获取 Inertia 挂载根节点（默认 id 为 'app'）
const el = document.getElementById('app');
// 🌟 2. 只有当根节点存在（即当前是 Inertia 页面）时才初始化
if (el) {
  createInertiaApp({
    // Disable progress bar
    //
    // see https://inertia-rails.dev/guide/progress-indicators
    // progress: false,
    // 💡 核心改动：在全局 title 回调里，除了检查具体的 title 文本，还可以设置最终的兜底策略
    title: (title) => {
      // 这里处理的是页面内部通过 <svelte:head><title>... 传出来的具体文字
      if (title) return `${title} - 分太极光`;
      
      // 如果页面完全没有定义 title，则交给全局兜底（这里可以是一个基础兜底）
      return '分太极光 Fentime Aurora';
    },
    resolve: (name) => {
      const pages = import.meta.glob('../pages/**/*.svelte', {
        eager: true,
      })
      const page = pages[`../pages/${name}.svelte`]
      
      const pageLayout = page.layout || page.default.layout || Layout;

      // 💡 【关键操作】：检查当前页面最终使用的布局是不是 AppLayout
      // 如果页面没传具体的 title 属性，我们就根据布局动态塞入一个默认 title
      if (pageLayout === AppLayout) {
        // 如果 Rails 没传 title，且 Svelte 页面组件上也没定义，就用后台默认标题
        page.default.title = page.default.title || '';
      } else {
        page.default.title = page.default.title || '';
      }

      return {
        default: page.default,
        layout: pageLayout
      }
    },

    setup({ el, App, props }) {
      if (el) {
        //mount(App, { target: el, props })
        hydrate(App, { target: el, props })
      } else {
        console.error(
          "Missing root element.\n\n" +
          "If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n" +
          'Consider moving <%= vite_javascript_tag "inertia" %> to the Inertia-specific layout instead.',
        )
      }
    },
  });
}
